<script setup lang="ts">
import {useAuthStore} from "~/store/admin/login/auth";
import UserButton from '~/components/ui/button/iconbutton.vue';
import LogoutButton from '~/components/ui/button/iconbutton.vue';
import {notification} from "ant-design-vue";

const auth = useAuthStore();

const onLogout = () => {
  auth.logout();
  notification.success({
    message : '로그아웃 되었습니다',
    placement : 'top',
    duration : 3,
  });
  navigateTo('/');
}
</script>

<template>
  <a-layout-header class="admin-header login-header">
    <div class="container-fluids1">
      <div class="header-top admin-header-top">
        <div class="header-left-box">
          <div class="logo-box">
            <NuxtLink to="/sys-admin">
              <img src="~/assets/img/pc/admin/login-logo.svg" alt="로고" />
            </NuxtLink>
          </div>
          <div class="header-login-info-box">
            <span class="text-span">웹사이트 운영을 위한 관리자 모드입니다.</span>
            <a-button href="/" target="_blank">사이트보기</a-button>
          </div>
        </div>
        <div class="header-right-box">
          <UserButton>
              <span class="icon-span">
                <img src="~/assets/img/pc/admin/admin-1.svg" alt="아이콘" />
              </span>
            <span class="text-span">{{auth.userName}}</span>
          </UserButton>
          <LogoutButton @click="onLogout">
              <span class="icon-span">
                <img src="~/assets/img/pc/admin/admin-2.svg" alt="아이콘" />
              </span>
            <span class="text-span">로그아웃</span>
          </LogoutButton>
        </div>
      </div>
    </div>
  </a-layout-header>
</template>

<style scoped lang="scss">

</style>